import React from "react";

const FormHeader = ({ Info }) => {
  return (
    <div className="row align-items-center">
      <div className="col-10">
        <h2>{Info.formName}</h2>
        <hr style={{ padding: "3px", background: "#F17146", opacity: 1 }} />
      </div>
      <div className="col-2">
        {Info.image && (
          <img
            className="form-logo"
            src={`https://erp.eshiksa.net/DirectFeesv3/assets/img/${Info.image}`}
            alt="logo"
          />
        )}
      </div>
    </div>
  );
};

export default FormHeader;
